import React, { useEffect, useState, useMemo, useCallback } from "react";
import TableBackground from "../../components/TableBackground";
import { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../components/Pagination/Pagination";
import SearchComponent from "../../components/Search";
import { getAgents } from "../../redux/Agents/agentsAction";
import EmptyState from "../../components/EmptyState";
import { useNavigate } from "react-router-dom";

const AgentsTable = () => {
  const [status, setStatus] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { agentsData, agentsTotal, agentsLoading } = useSelector(
    (state) => state.agents
  );

  // COMPLAINTS PAGE CHANGE
  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
    dispatch(getAgents({ page: page, value: status, search: searchValue }));
  };

  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        //  api to dispatch and make the actions for search
        dispatch(getAgents({ page: 1, value: status, search: val }));
      }, 750),
    [dispatch, status]
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  const getStatusBadge = (val) => {
    let result
    switch (val) {
      case 'pending':
        result = 'pending-badge'
        break;
      case 'inactive':
        result = 'error-badge'
        break
      case 'active':
        result = 'success-badge'
        break;
        case "completed":
          result = "success-badge"
          break;
          case "approved":
            result = "success-badge"
            break;
            case "rejected":
              result = "error-badge"
              break;
      default:
        result = 'error-badge'
        break
    }
    return result
  }

  const handleStatusChange = (tabStatus) => {
    setStatus(tabStatus);
    dispatch(getAgents({ page: 1, value: tabStatus, search: searchValue }));
  };

  useEffect(() => {
    dispatch(getAgents({ page: 1, value: status, search: searchValue }));
  }, [dispatch, status, searchValue]);

  return (
    <div>
      <TableBackground>
        <p className="text-primary font-semibold text-base leading-5 pt-4 px-4">
          Agents Profile
        </p>

        {/* SEARCH AND FILTER SECTION */}
        <section className="flex gap-4  pt-4">
          <div className="w-full relative px-4">
            <SearchComponent
              placeholder="Search..."
              searchValue={searchValue}
              handleChange={handleChange}
            />
          </div>
        </section>

        {/* TABS SECTION */}
        <section>
          <div className="flex gap-4 mt-4 mb-5 cursor-pointer px-4">
            <div
              className={
                status === "all"
                  ? "flex text-primary border-b-primary border-b-[2px] pb-[4px]"
                  : "flex text-[#96A397] pb-[4px]"
              }
              onClick={() => handleStatusChange("all")}
            >
              <div className="flex">
                <p className=" leading-[18px] text-sm font-semibold pr-[4px]">
                  All
                </p>
                <div
                  className={
                    status === "all"
                      ? "bg-[#DBFFDF] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                      : "bg-[#ECEEEC] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                  }
                >
                  <p>{status === "all" ? agentsTotal : "0"}</p>
                </div>
              </div>
            </div>

            <div
              className={
                status === "approved"
                  ? "flex text-primary border-b-primary border-b-[2px] pb-[4px]"
                  : "flex text-[#96A397] pb-[4px]"
              }
              onClick={() => handleStatusChange("approved")}
            >
              <div className="flex">
                <p className=" leading-[18px] text-sm font-semibold pr-[4px]">
                  Approved
                </p>
                <div
                  className={
                    status === "approved"
                      ? "bg-[#DBFFDF] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                      : "bg-[#ECEEEC] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                  }
                >
                  <p>{status === "approved" ? agentsTotal : "0"}</p>
                </div>
              </div>
            </div>

            <div
              className={
                status === "rejected"
                  ? "flex text-primary border-b-primary border-b-[2px] pb-[4px]"
                  : "flex text-[#96A397] pb-[4px]"
              }
              onClick={() => handleStatusChange("rejected")}
            >
              <div className="flex">
                <p className=" leading-[18px] text-sm font-semibold pr-[4px]">
                  Rejected
                </p>
                <div
                  className={
                    status === "rejected"
                      ? "bg-[#DBFFDF] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                      : "bg-[#ECEEEC] rounded-[4px] py-[2px] px-[4px]  leading-[14px] text-[10px] font-semibold "
                  }
                >
                  <p>{status === "rejected" ? agentsTotal : "0"}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-[30px] mb-[24px]">
          {agentsLoading ? (
            <div className="animate-pulse w-full mt-4 px-4 pb-4 mb-4">
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
            </div>
          ) : (
            <>
              {agentsData.length === 0 ? (
                <EmptyState text="There's no data for this filter yet" />
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th scope="col" className="px-4 pb-2">
                        First Name
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Last Name
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Phone Number
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Referrals
                      </th>

                      <th scope="col" className="px-4 pb-2">
                        {" "}
                        State
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        LGA
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Cooperatives
                      </th>
                      <th scope="col" className="px-4 pb-2">
                        Status
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {agentsData.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          className="relative cursor-pointer hover:bg-[#edf7ee]"
                          onClick={() => navigate(`/agent/${data?.id}`)}
                        >
                          <td className="px-4 capitalize">
                            {data?.first_name || "N/A"}
                          </td>
                          <td className="px-4 capitalize">
                            {data?.last_name || "N/A"}
                          </td>
                          <td className="px-4">
                            {data?.phone_number || "N/A"}
                          </td>
                          <td className="px-4">
                            {data?.referral_count || "N/A"}
                          </td>
                          <td className="px-4">{data?.state || "N/A"}</td>

                          <td className="px-4">{data?.lga || "N/A"}</td>
                          <td className="px-4">
                            {data?.cooperative_count || "N/A"}
                          </td>
                          {/* APPROVAL STATUS */}
                          <td className="">
                            <div
                              className={getStatusBadge(data.status)}
                            >
                              <p className="capitalize">
                                {data.status === "approved"
                                  ? data?.status
                                  : data?.status}
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}

          {!agentsLoading && agentsData.length > 0 ? (
            <div className="mt-1">
              <PaginationComponent
                page={currentPage}
                onPageChange={(page) => onPageChange({ page })}
                pageSize={10}
                totalItems={agentsTotal}
              />
            </div>
          ) : (
            ""
          )}
        </section>
      </TableBackground>
    </div>
  );
};

export default AgentsTable;
